import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// ANT DESIGN
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import {
  Card,
  Col,
  Collapse,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";

// PROJECT IMPORTS
import styles from "../../../../../assets/styles/styles";
import CustomButton from "../../../../../components/custom/CustomButton";
import MainLayout from "../../../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../../../components/layouts/enhancement/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../wallet.config";

const Withdraw = (props) => {
  const { Text, Title } = Typography;
  const { TextArea } = Input;
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // getTemplate();
    console.log(state);
  }, []);

  function onCancel() {
    navigate("/detail-wallet-account", { state: state });
  }

  const [ghost, setGhost] = useState(null);
  const Items = [
    {
      key: "1",
      label: "Show Payment Details",
      children: (
        <>
          <Row style={{ justifyContent: "spacebetween", marginTop: "15px" }}>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="accountNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.accountNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.accountNumber,
                    labelConfig.pleaseEnter
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="checkNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.chequeNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.chequeNumber,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="routingCode"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.routingCode}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.routingCode,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="receiptNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>
                    {labelConfig.receiptNumber}
                  </Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.receiptNumber,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                name="bankNumber"
                label={
                  <Text style={{ fontSize: "16px" }}>{labelConfig.bank}</Text>
                }
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.bank,
                    labelConfig.pleaseEnter
                  )}
                  // style={{ width: "30vh" }}
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
  ];

  function getTemplate() {
    const url = `${apiConfig.savingsAccounts}/${state.id}/transactions/template`;
    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempPaymentType = [];

        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentType.push({
            value: element.id,
            label: element.name,
          });
        });

        setPaymentTypeData(tempPaymentType);
        setIsLoading(false);
      }
    });
  }

  const onSubmit = (formValues) => {
    const url = `${apiConfig.savingsAccounts}/${state.id}/transactions`;
    const params = {
      command: "withdrawal",
    };
    formValues.transactionDate = BOM.DateTime(
      formValues.transactionDate,
      "only-date"
    );

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
      params,
    };
    // console.log(body);
    // return;
    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, "Savings Account was updated");
        navigate("/detail-wallet-account", {
          state: { ...state, statusValue: "active" },
        });
        //STOP LOAD
        setIsLoading(false);
      }
    });
  };
  return (
    <MainLayout pageItems={staticConfig.withdrawBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.withdrawMoney}
        createPageTitle={labelConfig.withdrawMoney}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <Row>
              <Divider orientation="left">{`Nuban No: ${state.accountNo}`}</Divider>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionDate}
                  name={"transactionDate"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.date),
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", height: 35 }}
                    disabledDate={BOM.DisabledAfterCurrentDate}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.transactionAmount}
                  name={"transactionAmount"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.transactionAmount),
                    },
                  ]}
                >
                  <InputNumber
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.amount)}
                    style={styles.ofInputFieldNumber}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={labelConfig.paymentTypes}
                  name={"paymentTypeId"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(labelConfig.paymentTypes),
                    },
                  ]}
                >
                  <Select
                    filterOption={(input, option) =>
                      (option?.label?.toLowerCase() ?? "").includes(
                        input?.toLowerCase()
                      )
                    }
                    placeholder={BOM.handlePlaceholderMsg(
                      labelConfig.paymentTypes,
                      "select"
                    )}
                    options={paymentTypeData}
                    showSearch
                  />
                </Form.Item>
              </Col>

              <Col span={24} style={{ padding: "0px 8px" }}>
                <Collapse
                  ghost={ghost}
                  items={Items}
                  bordered={false}
                  expandIconPosition={"end"}
                  style={{ padding: "0px", marginBottom: 15, marginTop: 15 }}
                  expandIcon={({ isActive }) => {
                    {
                      isActive ? setGhost(false) : setGhost(true);
                    }
                    return (
                      <>
                        {isActive ? (
                          <MinusOutlined
                            style={{
                              backgroundColor: "#92428B",
                              color: "white",
                              padding: 8,
                              borderRadius: 10,
                            }}
                          />
                        ) : (
                          <PlusOutlined
                            style={{
                              backgroundColor: "#92428B",
                              color: "white",
                              padding: 8,
                              borderRadius: 10,
                            }}
                          />
                        )}
                      </>
                    );
                  }}
                />
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.note} name="note">
                  <TextArea
                    placeholder={BOM.handlePlaceholderMsg(labelConfig.note)}
                  />
                </Form.Item>
              </Col>
            </Row>
            {/* <Row style={{ border: "1px solid red" }}> */}

            {/* </Row> */}

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#92428B"
                colorText="white"
                hoverBackground="#AD4EA7"
              />

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default Withdraw;
